export enum GlobalStateKeys {
  ACTIVE_CONCEPT = 'active-concept',
  ACTIVE_CONCEPT_ID = 'active-concept-id',
}
